import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import {route} from 'b302-frontend-library';

import University from '../../networking/models/University';
import Rating from '../layout/Rating';
import HanButton from './HanButton';
import MediaAccountList from '../client/partials/MediaAccountList';
import FavoriteIcon from '../client/partials/university/FavoriteIcon';
import {useFavorites} from '../../contexts/FavoritesContext';
import ExploreModel from '../../networking/models/ExploreModel';
import NoImage from "../../assets/images/no_image_available.jpg"

interface Props {
  university: ExploreModel;

  selected?: boolean;
  onCompareClick?: (university: University) => void;
  explore?: boolean;
}

const UniversityCardExplore: FunctionComponent<Props> = ({ university, explore }) => {
    const navigate = useNavigate();

    const { toggleFavorite, favoriteUniversities } = useFavorites();

    const openUniversity = () => {
        navigate(route('university-detail', university));
    };

    return (
        <div className={'university-card-explore'}>
            <img className={`university-card-explore__image ${!university?.image[0]?.url ? 'university-card-explore__image--empty' : ''}`} alt={university.name} src={university?.image[0]?.url ?? NoImage } />
            <div className='university-card-explore__info-container'>
                <div className={'university-card-explore__info'}>
                    <div className={'university-card-explore__title-container'}>
                        <div className={'university-card-explore__title'}>
                            <h4 className={'university-card-explore__text-title'}>{ university.name }</h4>

                            <FavoriteIcon
                                active={favoriteUniversities.includes(university.id!)}
                                onClick={() => toggleFavorite(university.id!)}
                                className={'university-card-explore__icon'}
                            />
                        </div>

                        {/* <Rating rating={university.rating!} sideText={`(${university.responses} responses)`}/> */}
                    </div>

                    <div>
                        <span className={'university-card-explore__text'}>{ university.country?.name ?? 'No Country' }</span>
                        <span className={'university-card-explore__text'}>{ university.city ?? 'No city' }</span>
                    </div>
                </div>

                <div className={'university-card-explore__footer'}>
                <div>
                    <div className={'university-card-explore__desc'}>
                        <span className={'university-card-explore__text university-card-explore__text--desc'}>
                            { university.description }
                        </span>
                    </div>

                    <div className={'university-card-explore__actions'}>
                        <div className={'flex flex--align-center'}>
                            <HanButton onClick={openUniversity} arrow>More information</HanButton>
                        </div>
                        <MediaAccountList accounts={university.social_media_accounts!} />
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default UniversityCardExplore;
